module.exports = __webpack_public_path__ + "img/Edit.54b945e9.svg";